<template>
    <referrals-data></referrals-data>
</template>
<script>
    import ReferralsData from "../layouts/components/ReferrersData";

    export default {
        components: {ReferralsData}
    }
</script>
